import type { SecurityEventSummary } from '@bartizo/shared';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { formatInstant } from '../lib/time.js';
import { Facts } from '../ui/DataTable.js';
import { AddressLink } from './AddressStatus.js';
import { Flag } from './Flag.js';

/** Under an event's row: when, where, from whom, what was done, who has it. */
export function EventRowDetail({
  event,
  timezone,
}: {
  event: SecurityEventSummary;
  timezone: string;
}): ReactNode {
  return (
    <div className="detail-grid">
      <section>
        <h4>What and where</h4>
        <Facts
          items={[
            ['Category', event.category],
            [
              'Server',
              <Link key="s" to={`/servers/${encodeURIComponent(event.serverId)}`}>
                {event.serverName}
              </Link>,
            ],
            ['Source address', event.sourceIp === null ? '—' : <AddressLink ip={event.sourceIp} />],
            ['Country', <Flag key="c" code={event.country} name />],
            ['Path', event.path === null ? '—' : <code>{event.path}</code>],
          ]}
        />
      </section>
      <section>
        <h4>When</h4>
        <Facts
          items={[
            ['Happened', formatInstant(event.occurredAt, { timezone })],
            ['Received', formatInstant(event.receivedAt, { timezone })],
          ]}
        />
      </section>
      <section>
        <h4>Response</h4>
        <Facts
          items={[
            ['Action taken', event.actionTaken ?? 'None recorded'],
            ['State', event.acknowledged ? 'Acknowledged' : 'Open'],
            ['Assigned to', event.assignee?.email ?? 'Nobody'],
            ['Note', event.hasNote ? 'Yes' : 'No'],
          ]}
        />
      </section>
      <section>
        <h4>Go to</h4>
        <Link to={`/events/${encodeURIComponent(event.id)}`}>Full event</Link>
      </section>
    </div>
  );
}
